module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Thin.9d7ee2b.woff";